import type { Screen } from "../../app/api/ApiClient";
import type { StateStore } from "../../app/state/StateStore";

import { ScreenMapper } from "./ScreenMapper";

type AccountScreen =
    Extract<Screen, { type: "account" }>;

export class AccountScreenMapper
    implements ScreenMapper<AccountScreen> {

    public readonly type = "account" as const;

    constructor(
        private readonly store: StateStore
    ) {}

    public apply(
        screen: AccountScreen
    ): void {

        const state =
            this.store.getState();

        this.store.replace({

            ...state,

            primaryScreen: {

                type: "account"

            },

            krok: null,

            currentKrokId: null,

            accountData:
                screen.data ?? screen,

            isAccountLoading: false,

            isLoading: false

        });

    }

}